import {addDays, startOfToday} from 'date-fns';

export const isProd =
  window.location.hostname.toLowerCase().endsWith('drinkagenda.com') &&
  !window.location.hostname.toLowerCase().startsWith('staging.');

export interface IDayData {
  lastUpdated?: object; // For storing only.
  alcoholGrams: number;
}

export interface IReason {
  key?: string; // Can be omitted when first storing the record.
  lastUpdated?: object; // For storing only.
  category: string;
  title: string;
  isFavorite: boolean;
  sortVal: number;
}

export interface IGoal {
  id?: string;
  key: string;
  enabled: boolean;
  lastUpdated?: object; // For storing only.
  sortVal: number;
}

export interface ITactic {
  key: string;
  lastUpdated?: object; // For storing only.
  isFavorite: boolean;
  sortVal: number;
}

export interface IClientSideTactic {
  ID: number;
  Source: string;
  Link: string;
  Title: string;
  Snippet: string;
  Tags: string[];
}

export interface IReport {
  key: string;
  enabled: boolean;
  lastUpdated?: object; // For storing only.
  sortVal: number;
}
export type Day = {
  year: number;
  month: number;
  day: number;
};
export type DayMap = Map<number, IDayData>;

export interface IDates {
  day: Day;
  date: Date;
  dateNum: number;
}

export const makeDates = (day: Day): IDates => {
  return {
    day: day,
    date: new Date(day.year, day.month - 1, day.day),
    dateNum: day.year * 10000 + day.month * 100 + day.day,
  };
};

export const toDates = (date: number) =>
  makeDates({
    year: Math.floor(date / 10000),
    month: Math.floor(date / 100) % 100,
    day: date % 100,
  });

export const dateToDates = (date: Date) =>
  makeDates({
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  });

export const nextDate = (date: IDates) => addDaysToDates(date, 1);

export const addDaysToDates = (date: IDates, days: number): IDates =>
  dateToDates(addDays(date.date, days));

export const getNow = (): IDates => dateToDates(startOfToday());

export const debug = isProd ? function () {} : console.log.bind(window.console);

export const GRAMS_PER_STD_DRINK = 14;

export const StdDrinks = (grams: number | null) =>
  grams === null ? null : Math.round((10 * grams) / GRAMS_PER_STD_DRINK) / 10;

export function getAndroidVersion(): number {
  const ua = navigator.userAgent.toLowerCase();
  const match = ua.match(/android\s([0-9.]*)/i);
  const ver = match ? match[1] : undefined;
  return parseFloat(ver ?? '0');
}

export function isIPhone(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  const match = ua.match(/iPhone/i);
  return !!match;
}

export function isSearchBot(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  const match = ua.match(/Googlebot|bingbot/i);
  return !!match;
}
